// import { InputSelect } from "#common/componentes/Inputs"
import { InputSelect } from "#common/input/InputSelect"
import { MESES } from "Components/Capacitaciones/constants_capacitaciones"
import { useState } from "react"

/**
 *
 * @param {*} props
 * @property {} props.data
 * @property {} props.value
 * @property {} props.maxWidth
 * @returns
 */
const SelectMonth = ({ value = "", setValue, ...props }) => {
	return (
		<InputSelect
			label="Mes"
			dataId="id"
			dataLabel="label"
			data={MESES}
			value={value}
			setValue={(value) => {
				// setSelectedMonth(value)
				if (typeof setValue === "function") setValue(value)
			}}
			fullWidth
			sx={{ maxWidth: props.maxWidth || "100%" }}
		/>
	)
}
export default SelectMonth
